@if ((unreadCount$ | async); as unreadCount) {
  @if (unreadCount !== 0) {
    <span
      [ngClass]="{ 'op-ian-bell--indicator': true, 'op-ian-bell--indicator_max': unreadCount > bellDisplayLimit }"
      data-test-selector="op-ian-notifications-count"
      [innerHTML]="unreadCountText$ | async"
    ></span>
  }
}
